exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-links .title[data-v-42a6f4ea],.footer-links ul>li>a[data-v-42a6f4ea]{color:#f5f5f5}.footer-links .list-marked li[data-v-42a6f4ea]{padding-left:25px}.footer-links .list-marked li[data-v-42a6f4ea]:before{left:4px}", ""]);

// exports
